import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {PublisherComponent} from './publisher.component';

import {CtaFormModule} from '../../cta-form/cta-form.module';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';

import '@sapudex/web-components/dist/Link.js';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    ConfigModule.withConfig({
      cmsComponents: {
        ProductPublisherComponent: {
          component: PublisherComponent,
        },
      },
    }),
    I18nModule,
    CtaFormModule,
    MediaModule,
    PublisherComponent,
  ],
  exports: [PublisherComponent],
})
export class PublisherModule {}
